import { FilterCommonTypes } from '../types-store';
import { FilterCommonValues, SubOptionType } from './types';

export const createNumberValue = (
  value: FilterCommonValues<FilterCommonTypes>[],
  subOptionType: SubOptionType,
  locale: string
) => {
  const number = value && value.find(f => f.subOptionType === subOptionType);
  return number && number.value?.toLocaleString(locale, { maximumFractionDigits: 15 });
};
